<div class="licese-text-container">
    <h2 class="mb-5x">{{ 'FRAGEBOEGEN_APP.LICENSE.TITLE' | translate }}</h2>
    <div [innerText]="licenseText"></div>
</div>
<common-ui-footer></common-ui-footer>
